import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import { log } from '@deck.gl/core';

var Tile2DHeader = function () {
  function Tile2DHeader(_ref) {
    var x = _ref.x,
        y = _ref.y,
        z = _ref.z,
        onTileLoad = _ref.onTileLoad,
        onTileError = _ref.onTileError;

    _classCallCheck(this, Tile2DHeader);

    this.x = x;
    this.y = y;
    this.z = z;
    this.isVisible = false;
    this.parent = null;
    this.children = [];
    this.content = null;
    this._isLoaded = false;
    this.onTileLoad = onTileLoad;
    this.onTileError = onTileError;
  }

  _createClass(Tile2DHeader, [{
    key: "loadData",
    value: function loadData(getTileData) {
      var _this = this;

      var x = this.x,
          y = this.y,
          z = this.z,
          bbox = this.bbox;

      if (!getTileData) {
        return;
      }

      this._loader = Promise.resolve(getTileData({
        x: x,
        y: y,
        z: z,
        bbox: bbox
      })).then(function (buffers) {
        _this.content = buffers;
        _this._isLoaded = true;

        _this.onTileLoad(_this);

        return buffers;
      })["catch"](function (err) {
        _this._isLoaded = true;

        _this.onTileError(err);
      });
    }
  }, {
    key: "data",
    get: function get() {
      return this._isLoaded ? this.content : this._loader;
    }
  }, {
    key: "isLoaded",
    get: function get() {
      return this._isLoaded;
    }
  }, {
    key: "byteLength",
    get: function get() {
      var result = this.content ? this.content.byteLength : 0;

      if (!Number.isFinite(result)) {
        log.error('byteLength not defined in tile data')();
      }

      return result;
    }
  }]);

  return Tile2DHeader;
}();

export { Tile2DHeader as default };
//# sourceMappingURL=tile-2d-header.js.map